"use client";

import Button from "@/components/ui/Button";
import { usePathname } from "next/navigation";
import { useRouter } from "nextjs-toploader/app";
import React from "react";
import AuthHeader from "./AuthHeader";

const AuthTabSwitcher = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const pathname = usePathname();
  const isLogin = pathname.includes("/login");

  return (
    <div className="w-full">
      {isLogin ? (
        <>
          <AuthHeader
            heading="Log In"
            description1="Welcome back. Let’s get you signed in and supported."
          />
        </>
      ) : (
        <>
          <AuthHeader
            heading="Signup"
            description1="Choose how you'd like to login"
          />
        </>
      )}

      <div className=" flex items-center space-x-2 mb-7 border-[#D0D5DD] border rounded-sm p-1">
        <Button
          type={pathname.includes("/login") ? "primary" : "default"}
          onClick={() => {
            router.push("/login");
          }}
          className="!border-0 w-full"
        >
          Login
        </Button>
        <Button
          type={pathname.includes("/signup") ? "primary" : "default"}
          onClick={() => {
            router.push("/signup");
          }}
          className="!border-0 w-full"
        >
          Signup
        </Button>
      </div>
      {children}
    </div>
  );
};

export default AuthTabSwitcher;
